import * as React from 'react';
import { View, Text, StyleSheet, ImageBackground, Image } from "react-native";
import Config from '../../constants/Config';
import { GetProductInCart, GetProductMeta, GetProductStockCount } from '../../constants/Utils';

import { ProductContext } from '../../contexts/product/Store';
import { AnalyticsService } from '../../constants/Analytics';
import { AuthContext } from '../../contexts/auth/Store';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
import StyledIcon from '../StyledIcon';
import { CartContext } from '../../contexts/cart/Store';
import { formatCurrency } from '../../utils/money';

const analytics = new AnalyticsService()

const ProductView = function ({ product, index }) {

    const authenticator = React.useContext(AuthContext)
    const buyer = authenticator.getUserData.buyerData

    const { product_state } = React.useContext(ProductContext)
    const [cart_state] = React.useContext(CartContext)

    const [meta, setMeta] = React.useState(null)
    const [inStock, setStock] = React.useState(undefined)
    const [inCart, setInCart] = React.useState(null)

    React.useEffect(() => {
        try {
            setMeta(GetProductMeta(product))
            setStock(GetProductStockCount(product))
            setInCart(GetProductInCart(cart_state, product?._id))
        } catch (e) {
            //
            console.log(e)
        }
        return () => { }
    }, [product, product_state, cart_state])

    return product
        ? <View
            style={[
                styles.container,
                inCart && styles.inCartCard,
                (index + 1)
                    ? (index + 1) % 2
                        ? styles.containerOdd
                        : styles.containerEven
                    : null
            ]}
        >
            <View style={styles.imageContainer}>
                {
                    product?.upload?.path
                        ? <ImageBackground
                            source={{
                                uri: `${Config.uploadUrl}${product?.upload?.path}`
                            }}
                            style={styles.imageBg}
                            resizeMode="contain"
                        ></ImageBackground>
                        : null
                }
                {
                    inCart
                        ? <View style={{
                            position: 'absolute',
                            top: 10,
                            right: 8,
                        }}>
                            <View style={[styles.cartCount, { flexDirection: 'row' }]}>
                                <StyledIcon
                                    iconName="md-checkmark"
                                    iconColor="white"
                                    iconOnly
                                    size={10}
                                />
                                <Text style={styles.cartCountText}>Added</Text>
                            </View>
                        </View>
                        : null
                }
            </View>

            <View style={styles.infoContainer}>
                <Text
                    style={styles.productName}
                    numberOfLines={2}
                >{product?.name}</Text>
                <Text
                    style={styles.productMetric}
                    numberOfLines={1}
                >{product?.case_count} {product.pricetag.mpu === product.case_count && product.pricetag.mpu === 1 ? product?.tags?.HIGHER_UNIT?.value : product?.tags?.LOWER_UNIT?.value + 's / ' + product?.tags?.HIGHER_UNIT?.value}</Text>
            </View>

            <View style={styles.priceContainer}>
                {
                    inStock
                        ? <>
                            <Text
                                style={styles.productPrice}
                                numberOfLines={1}
                            >{formatCurrency(product?.pricetag?.price)}</Text>

                            {
                                meta
                                    ? meta.discount
                                        ? <View style={styles.productDiscountContainer}>
                                            <Text style={styles.productDiscountPrice}>{formatCurrency(parseFloat(meta.discount))}</Text>
                                            <View style={styles.productDiscountBadge}>
                                                <StyledIcon
                                                    iconName="ios-flash"
                                                    iconColor={Colors.successText}
                                                    iconOnly
                                                    size={12}
                                                />
                                                <Text style={styles.productDiscountBadgeText}>Save {Math.abs(Math.ceil(((parseFloat(meta.discount) - product.pricetag.price) / product.pricetag.price) * 100))}%</Text>
                                            </View>
                                        </View>
                                        : meta.market_price
                                            ? <Text
                                                style={styles.productOldPriceContainer}
                                                numberOfLines={1}
                                            >
                                                <Text style={styles.productOldPriceStroke}>{formatCurrency(meta.market_price)}</Text>{' '}(Market Price)</Text>
                                            : null
                                    : null
                            }
                        </>
                        : inStock === undefined
                            ? null
                            : <Text style={[styles.productPrice, {
                                ...FontStyles.gray
                            }]}>Out of Stock</Text>
                }
            </View>
        </View>
        : null
}

export default ProductView

const styles = StyleSheet.create({
    container: {
        borderColor: '#E5EAF0',
        // borderWidth: 1,
        borderStyle: 'solid',
        borderTopWidth: 1,
        // borderRadius: 6,
        backgroundColor: Colors.whiteColor,
        flex: 1
    },
    containerOdd: {
        borderRightWidth: 1,
        marginLeft: -0.5
    },
    containerEven: {
        // borderLeftWidth: 0.5,
        marginRight: -0.5
    },
    imageContainer: {
        paddingTop: 10,
        paddingHorizontal: 12,
        paddingBottom: 14,
        // borderBottomColor: '#E5EAF0',
        // borderBottomWidth: 1,
        // borderStyle: 'solid',
    },
    imageBg: {
        width: '100%',
        height: undefined,
        minHeight: 100,
        aspectRatio: 133.33 / 75.79,
    },
    infoContainer: {
        paddingTop: 10,
        paddingHorizontal: 10,
        flexGrow: 1,
    },
    productName: {
        ...FontStyles.size13,
        ...FontStyles.lh18,
        ...FontStyles.normal,
        ...FontStyles.dark,
    },
    productMetric: {
        ...FontStyles.size12,
        ...FontStyles.lh14,
        ...FontStyles.normal,
        ...FontStyles.gray,
        marginTop: 2,
    },
    priceContainer: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingHorizontal: 10,
        minHeight: 44,
        justifyContent: 'flex-end',
    },
    productPrice: {
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        ...FontStyles.dark,
    },
    productOldPriceContainer: {
        ...FontStyles.size10,
        ...FontStyles.lh12,
        ...FontStyles.normal,
        color: Colors.dangerText,
        marginTop: 5,
    },
    productOldPriceStroke: {
        textDecorationLine: 'line-through'
    },
    productDiscountContainer: {
        flexDirection: 'row',
        marginTop: 5,
    },
    productDiscountPrice: {
        ...FontStyles.size13,
        ...FontStyles.lh15,
        ...FontStyles.normal,
        color: Colors.greyColor,
        textDecorationLine: 'line-through',
        alignSelf: 'center'
    },
    productDiscountBadge: {
        flexDirection: 'row',
        alignSelf: 'center',
        backgroundColor: Colors.successBackground,
        paddingHorizontal: 8,
        paddingVertical: 4,
        borderRadius: 4,
        marginLeft: 4
    },
    productDiscountBadgeText: {
        ...FontStyles.size12,
        ...FontStyles.lh15,
        ...FontStyles.semibold,
        color: Colors.successText,
        marginLeft: 3,
    },
    inCartCard: {
        // borderColor: Colors.greenColor + '4D',
        // borderWidth: 2,
    },
    cartCount: {
        ...FontStyles.white,
        ...FontStyles.semibold,
        ...FontStyles.size11,
        ...FontStyles.lh13,
        backgroundColor: Colors.greenColor,
        borderRadius: 16,
        paddingVertical: 4,
        paddingHorizontal: 6,
        alignSelf: 'flex-end'
    },
    cartCountText: {
        ...FontStyles.white,
        ...FontStyles.semibold,
        ...FontStyles.size11,
        ...FontStyles.lh13,
        alignSelf: 'flex-end',
        paddingLeft: 4
    }
})